import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Popover,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { MdChevronLeft, MdChevronRight, MdOutlineCancel } from "react-icons/md";
import { Link, useParams } from "react-router-dom";
import { AiOutlineLineChart } from "react-icons/ai";
import trash from "../../assets/icon/trash.svg";
import edit from "../../assets/icon/edit.svg";
import { GET_SINGLE_PRODUCTS, DELETE_PRODUCTS } from "../../Utils/Queries";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { IoChatboxOutline } from "react-icons/io5";
import {
  DELETE_PRODUCT,
  APPROVE_PRODUCT,
  REJECT_PRODUCT,
} from "../../Utils/Mutation";
import { GoGlobe } from "react-icons/go";
import { FiBox, FiEye, FiShoppingBag } from "react-icons/fi";
import Loader from "../Common/Loader";
import { useLazyQuery, useMutation } from "@apollo/client";
import { useSnackbarHook } from "../../hooks/useSnackbarHook";
import StatusChip from "../Common/StatusChip";
import { GoTrash } from "react-icons/go";
import { FiEdit3 } from "react-icons/fi";

const Overview = () => {
  const { id } = useParams();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [openAcceptModal, setOpenAcceptModal] = React.useState(false);
  const [openRejectModal, setOpenRejectModal] = React.useState(false);
  const [reason, setReason] = useState("");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenDeleteModal = () => {
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const open = Boolean(anchorEl);
  const pop_id = open ? "simple-popover" : undefined;

  const [getproducts, { loading, data, error, refetch }] = useLazyQuery(
    GET_SINGLE_PRODUCTS,
    {
      variables: {
        textToSearch: id,
      },
    },
  );

  const [
    deleteproducts,
    { loading: deleteLoading, data: deleteData, error: deleteError },
  ] = useMutation(DELETE_PRODUCT, {
    variables: {
      productId: id,
    },
  });

  const [approveProduct, { loading: approveLoading }] =
    useMutation(APPROVE_PRODUCT);

  const [rejectProduct, { loading: rejectLoading }] =
    useMutation(REJECT_PRODUCT);

  const { handleClick: enqueueSnackbar } = useSnackbarHook();

  const handleDeleteProduct = async () => {
    try {
      await deleteproducts({
        variables: { productId: id },
      });
      enqueueSnackbar("Product deleted successfully", { variant: "success" });
      handleCloseDeleteModal();
      // Optionally navigate back
    } catch (err) {
      enqueueSnackbar("Failed to delete product", { variant: "error" });
      console.error("Deletion failed", err);
    }
  };

  const handleApprove = async () => {
    try {
      await approveProduct({ variables: { productId: id } });
      enqueueSnackbar("Product approved successfully", { variant: "success" });
      refetch(); // refetch
      handleClose();
    } catch (err) {
      enqueueSnackbar("Failed to approve product", { variant: "error" });
    }
  };

  const handleReject = async () => {
    try {
      await rejectProduct({
        variables: { productId: id, reasonForRejection: reason },
      });
      enqueueSnackbar("Product rejected successfully", { variant: "success" });
      refetch(); // refetch
      setOpenRejectModal(false);
    } catch (err) {
      enqueueSnackbar("Failed to reject product", { variant: "error" });
    }
  };

  useEffect(() => {
    getproducts();
  }, [id]);
  const product = data?.fetchProductsWithFilter?.items;
  const productImages = product?.[0]?.images?.filter(Boolean) || [];

  useEffect(() => {
    setCurrentImageIndex(0);
  }, [id, productImages.length]);

  const handlePreviousImage = () => {
    if (!productImages.length) return;
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? productImages.length - 1 : prevIndex - 1,
    );
  };

  const handleNextImage = () => {
    if (!productImages.length) return;
    setCurrentImageIndex((prevIndex) =>
      prevIndex === productImages.length - 1 ? 0 : prevIndex + 1,
    );
  };

  console.log(product);
  return (
    <>
      {(loading || approveLoading || rejectLoading || deleteLoading) && (
        <Loader />
      )}
      <Box sx={{}}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
              <Link to="/dashboard/products">
                <Typography sx={{ fontSize: "13px", color: "#534f4fff" }}>
                  Products
                </Typography>
              </Link>
              <Typography>/</Typography>
              <Typography
                sx={{ fontSize: "13px", color: "#000", fontWeight: 500 }}
              >
                Product Overview
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 900, fontSize: "20px" }}>
                {" "}
                {product && product[0]?.name}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
            <Button
              onClick={handleOpenDeleteModal}
              startIcon={<GoTrash style={{ fontSize: "14px" }} />}
              variant="contained"
              sx={{ bgcolor: "#de3b40", borderRadius: "8px", px: 3 }}
            >
              Delete
            </Button>
            <Box sx={{ height: "25px", width: "1px", bgcolor: "#999191ff" }} />
            <Link to={`/dashboard/product/edit/${id}`}>
              <Button
                sx={{ borderRadius: "8px", px: 3 }}
                startIcon={<FiEdit3 style={{ fontSize: "14px" }} />}
                variant="contained"
              >
                Edit Product
              </Button>
            </Link>
          </Box>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Grid container spacing={2}>
            <Grid item lg={8} md={8}>
              <Box>
                <Box
                  sx={{
                    // border: "1px solid #dee1e6",
                    borderRadius: "16px",
                    bgcolor: "#fff",
                    overflow: "hidden",
                    display: "flex",
                    boxShadow: 1,
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      maxHeight: { xs: 320, md: 560 },
                      width: { xs: "100%", md: "50%" },
                      borderRight: { md: "1px solid #dee1e6" },
                      bgcolor: "#0f172a",
                      overflow: "hidden",
                    }}
                  >
                    {productImages.length > 0 ? (
                      <>
                        <Box
                          component="img"
                          src={productImages[currentImageIndex]}
                          alt={`${product?.[0]?.name} ${currentImageIndex + 1}`}
                          sx={{
                            width: "100%",
                            height: "100%",
                            maxHeight: { xs: 320, md: 560 },
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                        {productImages.length > 1 && (
                          <>
                            <IconButton
                              onClick={handlePreviousImage}
                              sx={{
                                position: "absolute",
                                left: 16,
                                top: "50%",
                                transform: "translateY(-50%)",
                                bgcolor: "rgba(15, 23, 42, 0.44)",
                                color: "#fff",
                                "&:hover": {
                                  bgcolor: "rgba(15, 23, 42, 0.68)",
                                },
                              }}
                            >
                              <MdChevronLeft size={24} />
                            </IconButton>
                            <IconButton
                              onClick={handleNextImage}
                              sx={{
                                position: "absolute",
                                right: 16,
                                top: "50%",
                                transform: "translateY(-50%)",
                                bgcolor: "rgba(15, 23, 42, 0.44)",
                                color: "#fff",
                                "&:hover": {
                                  bgcolor: "rgba(15, 23, 42, 0.68)",
                                },
                              }}
                            >
                              <MdChevronRight size={24} />
                            </IconButton>
                            <Box
                              sx={{
                                position: "absolute",
                                bottom: 18,
                                left: "50%",
                                transform: "translateX(-50%)",
                                display: "flex",
                                alignItems: "center",
                                columnGap: 1,
                                px: 1.25,
                                py: 0.75,
                                borderRadius: "999px",
                                bgcolor: "rgba(15, 23, 42, 0.44)",
                              }}
                            >
                              {productImages.map((image, index) => (
                                <Box
                                  key={`${image}-${index}`}
                                  onClick={() => setCurrentImageIndex(index)}
                                  sx={{
                                    width: index === currentImageIndex ? 18 : 8,
                                    height: 8,
                                    borderRadius: "999px",
                                    bgcolor:
                                      index === currentImageIndex
                                        ? "#fff"
                                        : "rgba(255, 255, 255, 0.45)",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                  }}
                                />
                              ))}
                            </Box>
                          </>
                        )}
                      </>
                    ) : (
                      <Box
                        sx={{
                          height: "100%",
                          minHeight: { xs: 320, md: 560 },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "rgba(255,255,255,0.7)",
                          px: 3,
                          textAlign: "center",
                        }}
                      >
                        <Typography>No product image available</Typography>
                      </Box>
                    )}
                  </Box>
                  <Box sx={{ flex: 1, p: 3, height: "100%" }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        columnGap: 2,
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>
                        <Typography sx={{ fontSize: "10px", fontWeight: 700 }}>
                          PRODUCT ID
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 500,
                            bgcolor: "#f3f4f6",
                            py: 0.5,
                            px: 1,
                            borderRadius: "4px",
                            mt: 1,
                          }}
                        >
                          {id}
                        </Typography>
                      </Box>

                      <Box>
                        <StatusChip
                          status={product && product[0]?.status}
                          outlined={true}
                        />
                      </Box>
                    </Box>

                    <Typography
                      sx={{
                        mt: 2,
                        color: "#7B408C",
                        fontWeight: 700,
                        fontSize: "30px",
                      }}
                    >
                      ${product && product[0]?.price}
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: "12px",
                        color: "#747171ff",
                      }}
                    >
                      Unit Price (Negotiable:{" "}
                      {product && product[0]?.isNegotiable === true
                        ? "Yes"
                        : "No"}
                      )
                    </Typography>
                    <Box
                      sx={{
                        mt: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box sx={{ mt: 2 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            columnGap: 1,
                          }}
                        >
                          <FiBox
                            style={{ fontSize: "14px", color: "#747171ff" }}
                          />
                          <Typography
                            sx={{ fontSize: "14px", color: "#747171ff" }}
                          >
                            Stock Level
                          </Typography>
                        </Box>

                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: "20px",
                            textAlign: "center",
                          }}
                        >
                          {product && product[0]?.stockHistory[0]?.quantity}{" "}
                          Units
                        </Typography>
                      </Box>
                      <Box sx={{ mt: 2 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            columnGap: 1,
                          }}
                        >
                          <GoGlobe
                            style={{ fontSize: "14px", color: "#747171ff" }}
                          />
                          <Typography
                            sx={{ fontSize: "14px", color: "#747171ff" }}
                          >
                            Origin
                          </Typography>
                        </Box>

                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: "20px",
                            textAlign: "center",
                          }}
                        >
                          {product && product[0]?.country?.name}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ mt: 2 }}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#747171ff",
                        }}
                      >
                        DESCRIPTION
                      </Typography>
                      <Typography sx={{ textAlign: "justify" }}>
                        {product && product[0]?.description}
                      </Typography>
                    </Box>

                    <Divider sx={{ my: 2 }} />
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        columnGap:2
                      }}
                    >
                      <Button
                        onClick={() => setOpenAcceptModal(true)}
                        startIcon={<IoIosCheckmarkCircleOutline />}
                        sx={{
                          border: "1px solid #747171ff",
                          borderRadius: "8px",
                          fontSize: "14px",
                          fontWeight: 600,
                          px: 4,
                          height: "45px",
                        }}
                      >
                        Approve
                      </Button>
                      <Button
                        onClick={() => setOpenRejectModal(true)}
                        startIcon={<MdOutlineCancel />}
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          px: 4,
                          height: "45px",
                          borderRadius: "8px",
                          border: "1px solid #FF3347",
                          color: "#FF3347",
                        }}
                      >
                        Reject
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item lg={4} md={4}>
              <Box
                sx={{
                  borderRadius: "16px",
                  boxShadow: 1,
                  bgcolor: "#fff",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    p: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    bgcolor: "#EBDCEF",
                  }}
                >
                  <Typography
                    sx={{ color: "#5C3069", fontSize: "12px", fontWeight: 600 }}
                  >
                    SELLER DETAILS
                  </Typography>
                  <Link
                    to={`/dashboard/user-details/${
                      product && product[0]?.merchant?._id
                    }`}
                  >
                    <Typography
                      sx={{
                        color: "#5C3069",
                        fontSize: "12px",
                        fontWeight: 500,
                      }}
                    >
                      View Profile
                    </Typography>
                  </Link>
                </Box>

                <Box sx={{ mt: 3 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Avatar sx={{ width: "80px", height: "80px" }} />
                    <Typography
                      sx={{ mt: 2, fontWeight: 700, fontSize: "18px", px:3, textAlign:'center' }}
                    >
                      {" "}
                      {product &&
                        `${product[0]?.merchant?.firstName} ${product[0]?.merchant?.lastName}`}
                    </Typography>
                    <Typography sx={{ color: "#333" }}>
                      Premium Seller Since{" "}
                      <b>
                        {product && formatDate(product[0]?.merchant?.createdAt)}
                      </b>
                    </Typography>
                  </Box>
                  <Box sx={{ px: 4, mt: 2, mb: 3 }}>
                    <Button
                      startIcon={<IoChatboxOutline />}
                      variant="outlined"
                      disabled
                      fullWidth
                      sx={{ border: "1px solid #333" }}
                    >
                      Message
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item lg={12} md={12}>
              <Box>
                <Typography sx={{ fontWeight: 700 }}>
                  Performance Analytics
                </Typography>
                <Typography sx={{ color: "#333", fontSize: "12px" }}>
                  Track sales volume and customer engagement over the last 7
                  days.
                </Typography>

                <Grid container spacing={2} sx={{ mt: 0 }}>
                  <Grid item lg={4}>
                    <Box
                      sx={{
                        bgcolor: "#fff",
                        borderRadius: "16px",
                        boxShadow: 1,
                        p: 2,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>
                        <Typography sx={{ color: "#333", fontWeight: 500 }}>
                          Total Sales
                        </Typography>
                        <Typography
                          sx={{
                            color: "#000",
                            fontWeight: 900,
                            fontSize: "20px",
                          }}
                        >
                          248
                        </Typography>
                        <Typography sx={{ fontSize: "12px" }}>
                          <span style={{ color: "#3FB763" }}>+12.5 </span> vs
                          last week
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          bgcolor: "#EBDCEF",
                          borderRadius: "50%",
                          width: "50px",
                          height: "50px",
                          display: "grid",
                          placeContent: "center",
                        }}
                      >
                        <FiShoppingBag
                          style={{ fontSize: "20px", color: "#7B408C" }}
                        />
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item lg={4}>
                    <Box
                      sx={{
                        bgcolor: "#fff",
                        borderRadius: "16px",
                        boxShadow: 1,
                        p: 2,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>
                        <Typography sx={{ color: "#333", fontWeight: 500 }}>
                          Product Views
                        </Typography>
                        <Typography
                          sx={{
                            color: "#000",
                            fontWeight: 900,
                            fontSize: "20px",
                          }}
                        >
                          {product && product[0]?.totalViews}
                        </Typography>
                        <Typography sx={{ fontSize: "12px" }}>
                          <span style={{ color: "#3FB763" }}> {product && product[0]?.totalViews} </span>{" "}
                          unique visitors
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          bgcolor: "#EBDCEF",
                          borderRadius: "50%",
                          width: "50px",
                          height: "50px",
                          display: "grid",
                          placeContent: "center",
                        }}
                      >
                        <FiEye style={{ fontSize: "20px", color: "#7B408C" }} />
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item lg={4}>
                    <Box
                      sx={{
                        bgcolor: "#fff",
                        borderRadius: "16px",
                        boxShadow: 1,
                        p: 2,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>
                        <Typography sx={{ color: "#333", fontWeight: 500 }}>
                          Conversion Rate
                        </Typography>
                        <Typography
                          sx={{
                            color: "#000",
                            fontWeight: 900,
                            fontSize: "20px",
                          }}
                        >
                          18.6%
                        </Typography>
                        <Typography sx={{ fontSize: "12px" }}>
                          <span style={{ color: "#3FB763" }}>+12.5 </span> sales
                          per view
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          bgcolor: "#EBDCEF",
                          borderRadius: "50%",
                          width: "50px",
                          height: "50px",
                          display: "grid",
                          placeContent: "center",
                        }}
                      >
                        <AiOutlineLineChart
                          style={{ fontSize: "20px", color: "#7B408C" }}
                        />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item lg={12} md={12}>
              <Box sx={{}}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <Typography sx={{ fontWeight: 700 }}>
                      Recent Orders
                    </Typography>
                    <Typography sx={{ color: "#333", fontSize: "12px" }}>
                      The latest customer purchases for this item.
                    </Typography>
                  </Box>
                  <Link to="/dashboard/orders">
                    <Typography sx={{ color: "#5C3069", fontSize: "13px" }}>
                      View All Orders
                    </Typography>
                  </Link>
                </Box>

                <Box
                  sx={{
                    mt: 2,
                    bgcolor: "#fff",
                    borderRadius: "16px",
                    boxShadow: 1,
                    p: 2,
                  }}
                >
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableCell sx={{ border: "none", fontSize: "14px" }}>
                          Order ID
                        </TableCell>
                        <TableCell sx={{ border: "none", fontSize: "14px" }}>
                          Customer
                        </TableCell>
                        <TableCell sx={{ border: "none", fontSize: "14px" }}>
                          Date
                        </TableCell>
                        <TableCell sx={{ border: "none", fontSize: "14px" }}>
                          Status
                        </TableCell>
                        <TableCell sx={{ border: "none", fontSize: "14px" }}>
                          Amount
                        </TableCell>
                      </TableHead>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Dialog open={openAcceptModal} onClose={() => setOpenAcceptModal(false)}>
        <DialogTitle>Confirm Approve</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to <b>APPROVE</b> this product?
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Typography sx={{ fontSize: "12px" }}>
              ID: #{product && product[0]?._id}
            </Typography>
            <Typography sx={{ fontSize: "12px" }}>
              Name: {product && product[0]?.name}
            </Typography>
            <Typography sx={{ fontSize: "12px" }}>
              Status: {product && product[0]?.status}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAcceptModal(false)}>Cancel</Button>
          <Button
            onClick={handleApprove}
            disabled={approveLoading}
            variant="contained"
            sx={{ bgcolor: "#3FB763", px: 3 }}
          >
            Approve
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openRejectModal} onClose={() => setOpenRejectModal(false)}>
        <DialogTitle>Confirm Reject</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to <b>REJECT</b> this product?
          </Typography>

          <Box sx={{ mt: 3 }}>
            <InputLabel>Reason for rejection</InputLabel>
            <TextField
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              margin="dense"
              placeholder="Provide a clear reason..."
              fullWidth
              multiline
              minRows={4}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRejectModal(false)}>Cancel</Button>
          <Button
            onClick={handleReject}
            disabled={rejectLoading || !reason}
            variant="contained"
            color="error"
            sx={{ px: 3 }}
          >
            Reject
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openDeleteModal} onClose={handleCloseDeleteModal}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this product?</Typography>
          <Box sx={{ mt: 2 }}>
            <Typography sx={{ fontSize: "12px" }}>
              ID: #{product && product[0]?._id}
            </Typography>
            <Typography sx={{ fontSize: "12px" }}>
              Name: {product && product[0]?.name}
            </Typography>
            <Typography sx={{ fontSize: "12px" }}>
              Status: {product && product[0]?.status}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteModal}>Cancel</Button>
          <Button
            onClick={handleDeleteProduct}
            disabled={deleteLoading}
            variant="contained"
            color="error"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Overview;

const formatDate = (dateString) => {
  const date = new Date(dateString);

  const day = date.getUTCDate();
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getUTCFullYear();

  return `${day} ${month} ${year}`;
};
